import { Endpoint, EndpointRoutes } from '../endpoint.interface';

export interface ServiceManagementEndpointRoutes extends EndpointRoutes {
  serviceManagement: {
    toString: () => string;
    getServiceManagementAemLabel: {
      toString: () => string;
    };
    getSpendBreakdownData: {
      toString: () => string;
    };
    getRepairCodeData: {
      toString: () => string;
    };
    getPaymentStatusData: {
      toString: () => string;
    };
  };
}
export interface ServiceManagementEndpoint extends Endpoint {
  baseUrl: string;
  routes: ServiceManagementEndpointRoutes;
}
